module.exports = "/packs/banner_sp_marketer-7c746952bc82bb024b5fbe098848305e.png";